// extracted by mini-css-extract-plugin
export default {"container":"TakeQuizPage_container__1GP+Y"};